const env = import.meta.env
const ensureEndSlash = (str) => str.trim().replace(/\/$/, '') + '/'
export const base_url = ensureEndSlash(env.VITE_API_URL);
export const home_url = ensureEndSlash(env.VITE_HOME_URL);
export const return_url = `${home_url}callback`;

export const uri = {
    api: {
        auth: {
            refresh: "auth/refresh",
            otp: {
                request: "auth/otp",
                confirm: "auth/otp"
            },
            google: `${base_url}auth/google`,
            redirect: {
                google: "auth/google/redirect"
            }

        },
        promotion: {
            list: 'promotion',
            use: (id) => `promotion/use/${id}`
        },
        wallet: {
            view: "wallet",
            history: "wallet/histories",
            charge: "wallet/online-charge",
            ipg: {
                list: "ipg",
                orders: "order",
                return: "ipg/return",
            },
            invoices: 'invoice',
        },
        ticket: {
            preview: "ticket/preview",
            list: "ticket",
            view: "ticket",
            reply: "ticket",
            open: "ticket",
            close: "ticket",
            department: {
                list: "ticket/department",
            },
            attachmentId: (id) => `${base_url}ticket/attachment/${id}`,
        },
        user: {
            logout: "user/authentication/logout",
            register: "auth/local/register",
            login: "auth/local/login",
            password: {
                update: "user/password/update",
                add: "user/password/add",
            },
            profile: {
                self: 'profile',
                password: 'profile/change-password',
                onboarding: 'profile/onboarding',
                real: 'profile/real',
                view: 'user/profile/view',
                update: 'user/profile/update',
                history: 'user/profile/history',
                validate: {
                    profile: "profile/validate",
                    mobile: "profile/validate/mobile",
                    email: "profile/validate/email"
                }
            }
        },
        media: {
            private: {
                stream: "media/private/stream",
                add: 'media/private/add-private'
            }
        },
        notification: {
            count: "notification",
            list: "notification"
        },
        iaas: {
            self: "iaas/",
            aggregate: {
                list: "iaas/",
            },
            pricing: (regionId) => "iaas/{RID}/pricing".replace('{RID}', regionId),
            region: {
                list: "iaas/regions",
            },
            interface: {
                list: "iaas/interface",
                resetIP(id) {
                    return this.view(id) + "/reset-ip"
                },
                view(id) {
                    return `iaas/interface/${id}`
                },
                availableTraffics(id) {
                    return this.view(id) + "/available-traffics"
                },
                buyTraffic(id) {
                    return this.view(id) + "/reserve-traffic"
                },
                active(id) { return this.view(id) + '/active' },
                sub(id, sub) { return this.view(id) + `/${sub}`; },
            },
            instance: {
                action: "iaas/instance",
                self: "iaas/instance",
                list: "iaas/instance",
                create: "iaas/instance",
                view: "iaas/instance",
                get(id) { return `iaas/instance/${id}` },
                sub(id, action) { return this.get(id) + `/${action}` },
            }
        }


    },
    admin: {
        financial: {
            wallet: {
                list: "manage/wallet",
                history: "manage/wallet",
                update: "manage/wallet",
            },
            pricing: {
                list: "manage/pricing",
                override: "manage/pricing",
                update: "manage/pricing",
            },
            ipg: {
                list: "manage/ipg",
                update: "manage/ipg",
                delete: "manage/ipg",
                create: "manage/ipg",
                plugin: {
                    list: "manage/ipg/plugins",
                }
            }
        },
        support: {
            ticket: {
                list: "manage/ticket",
                view: "manage/ticket",
                reply: "manage/ticket",
                open: "manage/ticket",
                close: "manage/ticket",
            },
            department: {
                list: "ticket/department", // FIXME: not similar to cloud
                add: "manage/department",
            },
            get: 'admin/support/item/get',
            add: 'admin/support/item/add',
            list: 'admin/support/item/list',
            edit: 'admin/support/item/edit',
        },
        user: {
            password: "manage/user",
            list: "manage/user",
            block: "manage/user",
            add: "manage/user",
            validation: "manage/user",
            profile: {
                update: "manage/profile",
                list: 'manage/profile',
            },
        },
        iaas: {
            self: "manage/iaas/",
            aggregate: {
                list: "manage/iaas/",
            },
            region: {
                list: "manage/iaas/regions",
            },
            instance: {
                action: "manage/iaas/instance",
                self: "manage/iaas/instance",
                list: "manage/iaas/instance",
                create: "iaas/instance",
                view: "manage/iaas/instance",
                get(id) { return `manage/iaas/instance/${id}` },
                sub(id, action) { return this.get(id) + `/${action}` },

            },
            interface: {
                list: "manage/iaas/interface",
                resetIP(id) {
                    return this.view(id) + "/reset-ip"
                },
                view(id) {
                    return `manage/iaas/interface/${id}`
                },
                availableTraffics(id) {
                    return this.view(id) + "/available-traffics"
                },
                buyTraffic(id) {
                    return this.view(id) + "/reserve-traffic"
                },
                active(id) { return this.view(id) + '/active' },
                sub(id, sub) { return this.view(id) + `/${sub}`; },
            },

        },
        rbac: {
            add: "manage/rbac",
            promote: "manage/rbac/add-child",
            revoke: "manage/rbac/remove-child",
            roles: {
                list: "manage/rbac/roles",
            },
            tasks: {
                list: "manage/rbac/tasks",
            },
            routes: {
                list: "manage/rbac/routes",
            },
            permissions: {
                list: "manage/rbac/permissions",
            },
        },
        cloud: {
            list: "cloud/private-cloud",
            user: {
                password: "cloud/user",
                list: "cloud/user",
                block: "cloud/user",
                add: "cloud/user",
                validation: "cloud/user",
                profile: {
                    update: "cloud/profile",
                    list: 'cloud/profile',
                },
            },
            region: {
                list: "cloud/region",
                create: "cloud/region",
                update: "cloud/region",
            },
            domain: { self: "cloud/domain" },
            networkUri(regionId) {
                return "cloud/region/{rid}/network".replace("{rid}", regionId)
            },
            updateNetworkUri(regionId, networkId) {
                return "cloud/region/{rid}/network{nid}".replace("{rid}", regionId).replace('{nid}', `/${networkId}`)
            },
            subnetUri(regionId, networkId) {
                return this.updateNetworkUri(regionId, networkId) + "/subnet"
            },
            updateSubnetUri(regionId, networkId, subnetId) {
                return this.subnetUri(regionId, networkId) + `/${subnetId}`
            },
            cloudPricing(regionId) {
                return "cloud/region/{rid}/pricing".replace("{rid}", regionId)
            },
            updateCloudPricing(regionId, priceId) {
                return "cloud/region/{rid}/pricing/{pid}".replace("{rid}", regionId).replace("{pid}", priceId)
            },
            iaas: {
                self: "cloud/iaas/",
                aggregate: {
                    list: "cloud/iaas/",
                },
                region: {
                    list: "cloud/iaas/regions",
                },
                instance: {
                    action: "cloud/iaas/instance",
                    self: "cloud/iaas/instance",
                    list: "cloud/iaas/instance",
                    create: "iaas/instance",
                    view: "cloud/iaas/instance",
                    get(id) { return `cloud/iaas/instance/${id}` },
                    sub(id, action) { return this.get(id) + `/${action}` },

                },
                interface: {
                    list: "cloud/iaas/interface",
                    resetIP(id) {
                        return this.view(id) + "/reset-ip"
                    },
                    view(id) {
                        return `cloud/iaas/interface/${id}`
                    },
                    availableTraffics(id) {
                        return this.view(id) + "/available-traffics"
                    },
                    buyTraffic(id) {
                        return this.view(id) + "/reserve-traffic"
                    },
                    active(id) { return this.view(id) + '/active' },
                    sub(id, sub) { return this.view(id) + `/${sub}`; },
                },

            },
            financial: {
                wallet: {
                    list: "cloud/wallet",
                    history: "cloud/wallet",
                    update: "cloud/wallet",
                },
                pricing: {
                    list: "cloud/pricing",
                    override: "cloud/pricing",
                    update: "cloud/pricing",
                },
                ipg: {
                    list: "cloud/ipg",
                    update: "cloud/ipg",
                    delete: "cloud/ipg",
                    create: "cloud/ipg",
                    plugin: {
                        list: "cloud/ipg/plugins",
                    }
                }
            },
            support: {
                ticket: {
                    list: "cloud/ticket",
                    view: "cloud/ticket",
                    reply: "cloud/ticket",
                    open: "cloud/ticket",
                    close: "cloud/ticket",
                },
                department: {
                    list: "cloud/department",
                    add: "cloud/department",
                },
                get: 'admin/support/item/get',
                add: 'admin/support/item/add',
                list: 'admin/support/item/list',
                edit: 'admin/support/item/edit',
            },





        },
    }

}

export const adminRoot = '/app';
export const cookieDomain = "/";
export const defaultLocale = 'fa'
export const defaultDirection = 'rtl'
export const localeOptions = [
    { id: 'en', name: 'English', direction: 'ltr' },
    { id: 'fa', name: 'فارسی', direction: 'rtl' },
]
